import { PostProcessingResult } from '@/app/log-viewer/post-processing/PostProcessor';
import { InternalMessage } from '@/workers/InternalMessages';

export const PostProcessingStarted = 'PostProcessingStarted';
export const PostProcessingCompleted = 'PostProcessingCompleted';
export interface PostProcessingCompletedMessage extends InternalMessage {
  result: PostProcessingResult;
}

export const PostProcessingError = 'PostProcesssingError';
export interface PostProcessingErrorMessage extends InternalMessage {
  error: Error;
}
